<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-cube-outline"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="8">
          <v-col cols="12">
            <v-text-field
                v-model="partnerDetail.name"
                filled
                label="Tên"
                placeholder="Nhập tên"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                v-model="partnerDetail.order"
                filled
                label="Vị trí"
                placeholder="Nhập vị trí"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
                label="Ảnh "
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                v-model="image"
                @change="uploadImg"
            ></v-file-input>
            <div v-if="display_image">
              <v-img
                  :src="display_image"
                  aspect-ratio="1.7"
                  contain
                  width="200"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" align="center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_DETAIL_PARTNER, UPDATE_PARTNER} from "@/store/modules/partner";
import { UPLOAD_IMAGE} from "@/store/modules/field_project";

export default {
  name: "Edit_partner",
  data() {
    return {
      page: "Danh sách Partner",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Partner",
          disabled: true,
        },
        {
          text: "Sửa Partner",
          disabled: false,
        },
      ],
      image: null,
      display_image: '',

    }
  },
  computed:{
    ...mapGetters({
      partnerDetail:"partnerDetail",
    })
  },
  watch:{
    partnerDetail(val) {
      if (val && val.photo_url) {
        this.display_image = this.url + val.photo_url;
      }
    }
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_DETAIL_PARTNER,this.$route.params.id);
  },
  methods:{
    uploadImg(e) {
      if (!e) {
        this.display_image = "";
        this.partnerDetail.photo_url = "";
      }
      this.display_image = URL.createObjectURL(e)
      this.$forceUpdate()
    },
    async save() {
      if (this.image != null) {
        let formDateAvatar = new FormData();
        formDateAvatar.append("upload", this.image);
        formDateAvatar.append("type", "ckeditor");
        formDateAvatar.append("position_type", "1");
        await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
              if (data.data.status == 1) {
                this.partnerDetail.photo_url = data.data.data[0].path
              }
            }
        )
      }
      await this.$store.dispatch(`${UPDATE_PARTNER}`, this.partnerDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/partner')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>